import { useSelectorEq } from "commons/store/common";
import { apiGcontextHomeTotal } from "pages/statistics/store/StatisticsR";
import { useEffect } from "react";
import type { IState } from "store/modules";
import { useApi } from "store/modules/common";

/**
 * 콘텍스트 > 홈 일 경우 호출
 */
export const useContextHomeTotal = () => {
  const { total, selectChannel } = useSelectorEq((state: IState) => ({
    total: state.statistics.homeTotal.provider,
    selectChannel: state.navigates.selectChannel,
  }));
  const { apiResult } = useApi();
  const contextTotalLoad = async () => {
    await apiResult(apiGcontextHomeTotal);
  };

  useEffect(() => {
    contextTotalLoad();
  }, [selectChannel]);
  return { total };
};
